import React from 'react';
import PropTypes from 'prop-types';
import './filter-button.css';

class FilterButton extends React.Component {
  render() {
    var iconText;
    var textLength;
    if(this.props.iconText) {
      textLength = this.props.iconText.length;
      iconText = (
        <div className={(textLength>1) ? 'icon-text icon-text-wide' : 'icon-text'}>{this.props.iconText}</div>
      );
    }

    return (
      <div
        disabled={this.props.disabled}
        className={`filter-button ${(this.props.selected) ? 'selected' : ''} ${(this.props.notSelected) ? 'not-selected' : ''} ${(this.props.disabled) ? 'disabled' : ''}`}
        onClick={(this.props.disabled) ? null : this.props.select}>
        {iconText || this.props.icon}
        <span className="filter-button-title" onClick={(this.props.disabled) ? null : this.props.select}>{this.props.title}</span>
        <div className='filter-button-selected-indicator'></div>
      </div>
    );
  }
}

FilterButton.propTypes = {
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  notSelected: PropTypes.bool,
  icon: PropTypes.element,
  iconText: PropTypes.string,
  select: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default FilterButton;


// WEBPACK FOOTER //
// ./src/components/filter/filter-button/filter-button.js